import styled from 'styled-components';
import { media } from 'helpers/breakpoints';
import { ArrowRedoOutlineIc } from '@dsch/dd-icons';

import { GhostButton } from 'components/Toolkit/Button/GhostButton';
export interface ShareAdProps {
  isUnderlined: boolean;
  handleShareAd: (t: boolean) => void;
  className?: string;
}

const Action = styled(GhostButton)<Pick<ShareAdProps, 'isUnderlined'>>`
  span {
    display: none;
  }

  &:hover {
    &:after {
      ${({ isUnderlined }) => !isUnderlined && 'display: none'}
    }
  }

  @media screen and (min-width: 40em) and (min-height: 768px) {
    span {
      display: inline;
    }
  }
`;

const Text = styled.span`
  ${({ theme }) => theme.fontSize.M14}

  ${media.smallOnly} {
    ${({ theme }) => theme.fontSize.B14}
  }
`;

const IconContainer = styled.div`
  color: ${({ theme }) => theme.colors.GREY_DARK};
`;

function shareAd(handleShareAd: (t: boolean) => void) {
  handleShareAd(true);
}

function ShareAd({ isUnderlined, className, handleShareAd }: ShareAdProps) {
  return (
    <Action
      className={className}
      onClick={() => shareAd(handleShareAd)}
      data-testid="share-cad"
      isUnderlined={isUnderlined}
    >
      <IconContainer>
        <ArrowRedoOutlineIc />
      </IconContainer>
      <Text>Share</Text>
    </Action>
  );
}

export { ShareAd };
